import React, { FC } from 'react';
import { Button, Tooltip } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { Edit } from 'common/svg';
import { ICity } from 'entities/City/City.models';

interface IComponentProps {
  item: ICity;
  onUpdate: (id: number) => void;
}

export const CityListItem: FC<IComponentProps> = ({ item, onUpdate }) => {
  const handleUpdate = (): void => {
    onUpdate(item.id);
  };

  return (
    <div className="py-5 flex align-center justify-between city-list-item">
      <span className="flex align-center">
        <span className="ff-medium fs-s">{item.name}</span>
        {item.parent && <span className="ml-3 ff-regular fs-s color-dark-grey">{`(${item.parent.name})`}</span>}
        {item.isAvailable && <span className="ml-3 ff-regular fs-s color-dark-grey">Доступен покупателям</span>}
        {item.locked && (
          <Tooltip title="Город используется в складе — его нельзя скрыть от покупателей">
            <LockOutlined className="ml-3 color-dark-grey" />
          </Tooltip>
        )}
      </span>

      <div className="flex align-center gap-6">
        <Button className="button-icon" icon={<Edit className="icon-dark-grey" />} onClick={handleUpdate} />
      </div>
    </div>
  );
};
